import { useState } from "react";
import ComingSoon from "./ComingSoon";
import PayoutReport from "./PayoutReport";

/**
 * Reporting, in the portal.
 *
 * These reports lived in a separate Appsmith app reading Xano's
 * reporting_module group. Appsmith is going away with Xano, so they move
 * here one tab at a time. Payout is the one the finance desk runs every
 * week, so it is the one that is built; the rest are named so nobody has
 * to guess what is still outstanding.
 */
const TABS = [
  { key: "payout", label: "Payout", source: "reporting_module/order_list" },
  { key: "dashboard", label: "Dashboard", source: "reporting_module" },
  { key: "all-leads", label: "All Leads", source: "reporting_module/retail_leads" },
  { key: "orders", label: "Orders", source: "reporting_module/order_list" },
  { key: "meetings", label: "Meetings", source: "reporting_module/interactions" },
  {
    key: "leads-dashboard",
    label: "Leads Dashboard",
    source: "reporting_module/retail_leads_counts",
  },
  {
    key: "generic-order",
    label: "Generic Order",
    source: "reporting_module/generic_order_list",
  },
  {
    key: "staff-performance",
    label: "Staff Performance",
    source: "reporting_module/staffPerformance_new",
  },
  {
    key: "partner-performance",
    label: "Partner Performance",
    source: "reporting_module/staffPerformance_new_partner",
  },
] as const;

export default function ReportsPage(): JSX.Element {
  const [active, setActive] = useState<(typeof TABS)[number]["key"]>("payout");
  const tab = TABS.find((t) => t.key === active) ?? TABS[0];

  return (
    <div className="flex h-full w-full flex-col gap-4 overflow-auto rounded-xl bg-white-A700 px-6 py-5 font-inter">
        <h1 className="text-lg font-semibold text-[#333333]">Reports</h1>

        <nav className="flex gap-1 overflow-x-auto border-b">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setActive(t.key)}
              className={`-mb-px whitespace-nowrap border-b-2 px-4 py-2 text-sm font-medium ${
                active === t.key
                  ? "border-blue-700 text-blue-700"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>

        {active === "payout" ? (
          <PayoutReport />
        ) : (
          <ComingSoon title={tab.label} source={tab.source} />
      )}
    </div>
  );
}
